// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationSnoozePath = 'M80 13c0 .781-.18 1.52-.499 2.18l2.124 7.925a16.676 16.676 0 013.842.011l2.094-7.813a5 5 0 116.7 2.158l-2.137 7.97C96.85 28.333 100 33.548 100 39.5v18C100 76 88.1 91 73.5 91H0v-3.5c0-.17.144-12.624 11.027-16.416A32.695 32.695 0 018.4 58.2c0-18.115 14.685-32.8 32.8-32.8 10.508 0 19.862 4.941 25.865 12.627.475-5.377 3.53-10.012 7.919-12.662l-2.1-7.833A5 5 0 1180 13zm-6.012 46.1H74V39.5a9.5 9.5 0 0119 0v18C93 73.4 82.9 84 73.5 84H61.454a32.804 32.804 0 0012.534-24.9zM67 58.2c-.055-14.21-11.59-25.7-25.8-25.7a25.8 25.8 0 00-19.738 42.416A21.793 21.793 0 0120.7 69.1c0-12.4 8.5-21.8 19.8-21.8h1.4c8.3 0 14.4 5.8 14.4 13.5 0 7.417-5.983 13.445-13.4 13.5v-7a6.4 6.4 0 006.4-6.5c0-3.8-3-6.5-7.4-6.5h-1.4c-7.4 0-12.8 6.2-12.8 14.8A14.8 14.8 0 0042.4 84h1.083A25.8 25.8 0 0067 58.401V58.2zM7.6 84c.733-2.524 2.593-5.58 6.985-6.627A32.992 32.992 0 0020.945 84H7.6z';
var IllustrationSnooze = baseIllustration('IllustrationSnooze', {
  getPath: () => IllustrationSnoozePath
}, 'ColoredIllustrationSnooze');

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationSnooze;
//# sourceMappingURL=index.js.map